import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import CatalogJewelryDataService from "../../services/catalog-jewelry.service";
import { NotificationManager } from "react-notifications";

import { useTranslation } from "react-i18next";
import { Spin, Tooltip } from "antd";


const CreateDiscardCollection = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const dealerID = searchParams.get("DealerID");
    const summaryID = searchParams.get("SummaryID");
    if (dealerID && summaryID) {
      handleCreateDiscardCollection(dealerID, summaryID);
    }
  }, []);

  const handleCreateDiscardCollection = (id, summaryId) => {
    try {
      let inputData = {
        dealerID: id.toString(),
        summaryID: summaryId.toString(),
      };
      setLoading(true);
      CatalogJewelryDataService.CreateDiscardCollection(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;

          if (message === "Success") {
            NotificationManager.success(
              t("Collection has been created successfully.")
            );
            setLoading(false);

            setTimeout(() => {
              navigate("/");
            }, 2000);
          } else {
            NotificationManager.error(t("Collection has not been created."));
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <>
      <Spin spinning={loading}>
        <div style={{ height: "100vh" }}></div>
      </Spin>
    </>
  );
};

export default CreateDiscardCollection;
